import { useTranslation } from "react-i18next";
import { ButtonLink } from "../Common/ButtonLink";

export const PrintButton = ({ print }: { print: typeof window.print }) => {
  const { t } = useTranslation();
  return (
    <ButtonLink
      styleVariant="primary"
      leftIconName="printer"
      size="small"
      onClick={print}
      style={{ padding: 0 }}
    >
      {t("button-print")}
    </ButtonLink>
  );
};
